import "./BrandMark.css";

/** The approved Play Store artwork, unchanged and shared by every web surface. */
export function BrandMark({ className = "" }: { className?: string }) {
  return (
    <img
      className={`brand-mark ${className}`.trim()}
      src="/brand/todays-brief-app.png"
      width="512"
      height="512"
      alt=""
      aria-hidden="true"
      draggable={false}
      decoding="async"
    />
  );
}
